import { ArrayValue } from '@coveo/bueno';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { buildContentURL, } from '../../api/search/html/html-api-client.js';
import { isErrorResponse } from '../../api/search/search-api-client.js';
import { validatePayload } from '../../utils/validate-payload.js';
import { buildResultPreviewRequest, } from './result-preview-request-builder.js';
export const fetchResultContent = createAsyncThunk('resultPreview/fetchResultContent', async (options, { extra, getState, rejectWithValue }) => {
    const state = getState();
    const req = await buildResultPreviewRequest(state, options);
    const res = await extra.apiClient.html(req);
    if (isErrorResponse(res)) {
        return rejectWithValue(res.error);
    }
    return {
        content: res.success,
        uniqueId: options.uniqueId,
    };
});
export const nextPreview = createAction('resultPreview/next');
export const previousPreview = createAction('resultPreview/previous');
export const preparePreviewPagination = createAction('resultPreview/prepare', (payload) => validatePayload(payload, { results: new ArrayValue({ required: true }) }));
const MAX_GET_LENGTH = 2048;
export const updateContentURL = createAsyncThunk('resultPreview/updateContentURL', async (options, { getState, extra }) => {
    const state = getState();
    const contentURL = buildContentURL(await options.buildResultPreviewRequest(state, {
        uniqueId: options.uniqueId,
        requestedOutputSize: options.requestedOutputSize,
    }), options.path);
    if (contentURL?.length > MAX_GET_LENGTH) {
        extra.logger.error(`The content URL was truncated as it exceeds the maximum allowed length of ${MAX_GET_LENGTH} characters.`);
    }
    return {
        contentURL: contentURL,
    };
});
